import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/4. End beneficiaries.png'

const Beneficiaries = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'number_of_end_beneficiaries')}
            text="Number of end beneficiaries"
        />
    );
}

export default Beneficiaries;